export default __webpack_public_path__ + "static/media/realTimeInfo.bfc30f68.svg";